import styled from "styled-components";
import { GridPageStyled, GridContainerStyled, GridTitleContainerStyled, GridImageContainerStyled, ButtonContainerStyled, ComingSoonTempStyled } from "./GridCommanStyles";
import {Grid} from "@mui/material";
import {LogoContainerStyled, ImageContainerFrontStyled, ImageContainerBackStyled} from "../../pages/Lsd";


function KababElDeeraGrid({setTriggerGrid, setIsClicked, isClicked}) {

  return (
    <>
            <GridPageStyled>
                <GridTitleContainerStyled>
                Kabab Al Deera
                </GridTitleContainerStyled>
                <GridContainerStyled>
                    <Grid container spacing = {2} rowSpacing={2}>
                        <Grid item xs = {12} sm = {12}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/1-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {8}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/2-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/3-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/4-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {8}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/5-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {12}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/6-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {8}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/7-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/8-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {12}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/9-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/10-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/11-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {4}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/12-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {6}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/13-LSD-Website-Deera.jpg"/>
                            </GridImageContainerStyled>
                        </Grid>
                        <Grid item xs = {12} sm = {6}>
                            <GridImageContainerStyled>
                                <img src = "/lsd_pics/kababAlDeera-grid/14-LSD-Website-Deera.jpg" style = {{marginBottom: "20px"}}/>
                            </GridImageContainerStyled>
                        </Grid>
                      </Grid>
                </GridContainerStyled>
            </GridPageStyled>
    </>
)
}



export default KababElDeeraGrid;